import React, { useState } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { NavLink } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './AppNavbar.css';

function AppNavbar() {
  const [expanded, setExpanded] = useState(false); // <-- add state

  const handleNavClick = () => {
    setExpanded(false); // Close navbar after link is clicked
  };

  return (
    <Navbar
      bg="white"
      expand="lg"
      expanded={expanded} // <-- control collapse manually
      onToggle={() => setExpanded(!expanded)} // <-- update toggle state
      className="shadow-sm nav-bar"
    >
      <Container>
        <Navbar.Brand as={NavLink} to="/" onClick={handleNavClick}>
          <img
            src="/img/signmates_logo_header.svg"
            alt="SignMates"
            width="120"
            className="d-inline-block align-top"
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="main-navbar" />
        <Navbar.Collapse id="main-navbar">
          <Nav className="ms-auto">
            <NavLink to="/" className="nav-link" onClick={handleNavClick}>🏠 Home</NavLink>
            <NavLink to="/info" className="nav-link" onClick={handleNavClick}>🔍 Sign & Deaf Info</NavLink>
            <NavLink to="/learn" className="nav-link" onClick={handleNavClick}>📘 Learn</NavLink>
            <NavLink to="/practice" className="nav-link" onClick={handleNavClick}>📷 Practice</NavLink>
            <NavLink to="/tools" className="nav-link" onClick={handleNavClick}>🛠️ Tools</NavLink>
            <NavLink to="/games" className="nav-link" onClick={handleNavClick}>🎮 Games</NavLink>
            <NavLink to="/simulator" className="nav-link" onClick={handleNavClick}>🧠 Simulator</NavLink>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default AppNavbar;
